import { useCallback } from 'react';
import { useFieldArray } from '../../../contexts';
import { createBlankCondition } from '../../../utils/conditionalContent/createBlankCondition';
import { useClauseConditionsFieldPath } from '../fieldPaths/useClauseConditionsFieldPath';

export const useAddCondition = () => {
  const fieldPath = useClauseConditionsFieldPath();
  const { append } = useFieldArray({ name: fieldPath });
  return useCallback(() => append(createBlankCondition()), [append]);
};
